import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ServidorRecad } from 'app/model/servidorRecad';
import { TrabalhadorEstrangeiroPosRecadDto } from './trabEstrangeiroPosRecad.dto';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PosCampanhaServiceAba6 } from 'app/service/posCampanhaAba6/pos-campanha-aba6.service';
import { Observable } from 'rxjs';
import { ModalComponent } from 'app/components/modal/modal.component';

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
  anexo: string;
  check: boolean;
}

@Component({
  selector: 'app-aba6-posrecad',
  templateUrl: './aba6-posrecad.component.html',
  styleUrls: ['./aba6-posrecad.component.sass']
})
export class Aba6PosrecadComponent implements OnInit {
  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosTrabEstrangeiro: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoTrabEstrangeiro: boolean;

  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];

  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  trabEstrangeiro: TrabalhadorEstrangeiroPosRecadDto;
  salvo: boolean = false;
  panelOpenState = false;

  justificativa: string = '';
  isDisabledJustificativa: boolean = true
  dadosTrabalhadorEstrangeiro: TrabalhadorEstrangeiroPosRecadDto
  constructor(private toasterService: ToastrService, public dialog: MatDialog, private posCampanhaServiceAba6: PosCampanhaServiceAba6) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.salvo = false;
    this.justificativa = "";
     this.findLotacao(this.servidor.id)
  }
  findLotacao(recadServidorId: number) {
    this.getObterTrabalhadorEstrangeiro(recadServidorId).subscribe(
      response => {
        this.dadosTrabalhadorEstrangeiro = response

        if (response) {
          this.dataSource.data =  this.montarDadosTabela(response)
         
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  private getObterTrabalhadorEstrangeiro(recadServidorId: number): Observable<any> {
    return this.posCampanhaServiceAba6.getObterTrabalhadorEstrangeiro(recadServidorId);
  }
  
  private montarDadosTabela(resp: TrabalhadorEstrangeiroPosRecadDto): DadosTabela[] {
    this.list.push(
      
      { descricao: "Data de Chegada ao Brasil", informacaoSrh: resp.dataChegadaSrh, anexo: "anexo-tipo-deficiencia", informacaoRecad: resp.dataChegadaRecad, check: true },
    { descricao: "Classificação da Condição de Ingresso", informacaoSrh: resp.descricaoClassificacaoSrh, anexo: "anexo-tipo-deficiencia", informacaoRecad: resp.descricaoClassificacaoRecad, check: true },
    { descricao: "Casado(a) Com Brasileiro(a)", informacaoSrh: resp.casadoBrasileiroSrh, anexo: "anexo-tipo-deficiencia", informacaoRecad: resp.casadoBrasileiroRecad, check: true },
    { descricao: "Tem Filhos Brasileiros", informacaoSrh: resp.filhoBrasileiroSrh, anexo: "anexo-tipo-deficiencia", informacaoRecad: resp.filhoBrasileiroRecad, check: true },

    )
    return this.list;
  }


  visualizarComprovante() { 
    this.getArquivoTrabalhadorEstrangeiro().subscribe(
      response => {
      const blobUrl = URL.createObjectURL(response);

      // Especifica as dimensões da nova janela (largura x altura)
      const newWindow = window.open(blobUrl, '_blank', 'width=800,height=800');

      // Verifica se a janela foi aberta com sucesso
      if (newWindow) {
        newWindow.focus();
      } else {
        this.toasterService.warning('Erro ao abrir a nova janela.', '', {
          timeOut: 1500
        });
      }
    },
    error => {
      this.toasterService.warning('Erro ao visualizar o arquivo.', '', {
        timeOut: 1500
      });
    }
  );
}

getArquivoTrabalhadorEstrangeiro(): Observable<any> {
    return this.posCampanhaServiceAba6.getArquivoTrabalhadorEstrangeiro(this.dadosTrabalhadorEstrangeiro.recadValidacaoEstrageiroId);

  }

  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosTrabEstrangeiro.emit(true);

        }
      }
    });
  }
  rejeitar(){
    this.isDisabledJustificativa = false
    this.openDialog();
  }

  aprovar(status){
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosTrabEstrangeiro.emit(true);
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      id: this.servidor.id,
      status: status,
      justificativa: this.justificativa,
     
    }
    this.posCampanhaServiceAba6.postDadosTrabalhadorEstrangeir(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    },
    (error) => {
      this.toasterService.error('Erro ao salvar os dados.', '', {
        timeOut: 1500
      });
    });
  }

}
